import { createSelector, MemoizedSelector } from '@ngrx/store';
import {
  CustomUnavailableProductsListState,
  StateWithUnavailableProducts
} from '../custom-unavailable-products-state';
import { getUnavailableProductsListState } from './feature-selector';

export const getAllUnavailableProductsListState: MemoizedSelector<
  StateWithUnavailableProducts,
  any[]
> = createSelector(
  getUnavailableProductsListState,
  (state: CustomUnavailableProductsListState) => state?.unavailableproducts
);


